import { ItemDesc, Category } from './types';
import { Vector3 } from 'three';
import { cdnUrl } from '@mp/common';

export class AppState {
  sid: string = '';
  items: Map<Category, ItemDesc[]> = new Map();
  slots: Map<string, Category> = new Map();
}

export const slots: Map<string, Category> = new Map();
slots.set('slot_1', Category.CG);

const CGItems: ItemDesc[] = [
  {
    name: '立食用',
    url: cdnUrl + 'hanntennkagu.glb',
    categories: [Category.CG],
    position: new Vector3(16, 1.5, -1),
    rotation: new Vector3(0, 0, 0),
    scale: new Vector3(1, 1, 1),
  },
  {
    name: 'パーテーション',
    url: cdnUrl + 'hantenpart.glb ',
    categories: [Category.CG],
    position: new Vector3(16, 1.5, -1),
    rotation: new Vector3(0, 0, 0),
    scale: new Vector3(1, 1, 1),
  }, 
  {
    name: 'CGなし',
    url: 'null',
    categories: [Category.CG],
    position: new Vector3(1, -1, 0.5),
    rotation: new Vector3(0, 0, 0),
    scale: new Vector3(0.3, 0.3, 0.3),
  },
];

export const items: Map<Category, ItemDesc[]> = new Map();
items.set(Category.CG, CGItems);
